import { render } from "./TemplateEditForm.vue?vue&type=template&id=35e115d5&scoped=true"
import script from "./TemplateEditForm.vue?vue&type=script&lang=js"
export * from "./TemplateEditForm.vue?vue&type=script&lang=js"

import "./TemplateEditForm.vue?vue&type=style&index=0&id=35e115d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e115d5"]])

export default __exports__